import {Action} from '@ngrx/store';
import {TitleBreadcrumb} from '../../shared/models/title';
import {AppConfigLocation} from '../../shared/models/app';
import {ButtonConfig} from '../../shared/models/button';
import {SubtitleItem} from '@src/core/state/title.state';

export const TITLE_CHANGE = '[Title] title changed';
export const TITLE_BREADCRUMBS_CHANGE = '[Title] changed breadcrumbs';

export class TitleChangedAction implements Action {
  readonly type = TITLE_CHANGE;


  constructor(
    public displayIcon: string | null,
    public displayTitle: string,
    public displaySubtitle: SubtitleItem[] = [],
    public weatherLocation: AppConfigLocation = null,
    public buttons: ButtonConfig[] = [],
  ) {
  }
}

export class TitleBreadcrumbsChangedAction implements Action {
  readonly type = TITLE_BREADCRUMBS_CHANGE;


  constructor(
    public breadcrumbs: TitleBreadcrumb[],
  ) {
  }
}


export type Actions =
  TitleChangedAction |
  TitleBreadcrumbsChangedAction;
